import React from 'react';
import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SIDEBAR_ACTION_HOVER_GROUP } from '../utils/sidebar-action-hover';

interface ScalingHelpIconProps {
  className?: string;
  size?: number;
  hoverGroup?: string;
}

export const ScalingHelpIcon: React.FC<ScalingHelpIconProps> = ({
  className,
  size,
  hoverGroup = SIDEBAR_ACTION_HOVER_GROUP,
}) => {
  return (
    <HelpCircle
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300',
        `group-hover/${hoverGroup}:scale-110`,
        className,
      )}
    />
  );
};
